<script setup lang="ts">
  import { infoListWrapperClass } from './InfoList.css.ts';
  import InfoListItem from './InfoListItem/InfoListItem.vue';
  import type { InfoListItemProps } from './InfoListItem';

  export type InfoListProps = {
    id?: string;
    testId?: string;
    title?: string;
    items: InfoListItemProps[];
    withHover?: boolean;
    wideSpacing?: boolean;
    compactSpacing?: boolean;
    noBorder?: boolean;
  };

  defineProps<InfoListProps>();
</script>

<template>
  <div :class="infoListWrapperClass">
    <template v-for="item in items" :key="item.slotKey || item.label">
      <InfoListItem
        v-bind="item"
        :with-hover="withHover"
        :wide-spacing="wideSpacing"
        :compact-spacing="compactSpacing"
        :no-border="noBorder"
        v-if="!item.hidden"
      >
        <template #[item.slotKey]="slotProps" v-if="item.slotKey">
          <slot :name="item.slotKey" v-bind="slotProps" />
        </template>
      </InfoListItem>
    </template>
  </div>
</template>
